/* import __COLOCATED_TEMPLATE__ from './connect-cta.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';
import type AppService from 'embercom/services/app-service';
import { type StandalonePlatform } from 'embercom/objects/standalone/constants';

interface Args {
  onClick: () => void;
  page: 'suggestions' | 'analyze' | 'topics';
  platform: StandalonePlatform | 'zendesk' | 'salesforce';
  useNewDesign?: boolean;
}

export default class ConnectCta extends Component<Args> {
  @service declare appService: AppService;
  @service declare intl: IntlService;

  get platform() {
    return this.args.platform;
  }

  get isPlatformConnected() {
    return this.appService.mainStandalonePlatform.isConnected;
  }

  get titleIcon() {
    return this.isSuggestionsPage ? 'stars' : 'sync';
  }

  get isSuggestionsPage() {
    return this.args.page === 'suggestions';
  }

  get title() {
    switch (this.args.page) {
      case 'suggestions':
        return this.intl.t('standalone.analyze.connect-cta.no-suggestions');
      case 'topics':
        return this.intl.t('standalone.analyze.connect-cta.no-topics');
      case 'analyze':
        return this.intl.t('standalone.analyze.connect-cta.no-analyze');
    }
  }

  get description() {
    switch (this.args.page) {
      case 'suggestions':
        return this.intl.t('standalone.analyze.connect-cta.suggestions-description');
      case 'topics':
        return this.intl.t('standalone.analyze.connect-cta.topics-description');
      case 'analyze':
        return this.intl.t('standalone.analyze.connect-cta.insights-description');
    }
  }

  get syncDescription() {
    if (this.zendesk) {
      return this.intl.t('standalone.analyze.connect-cta.zendesk.sync-description');
    } else if (this.salesforce) {
      return this.intl.t('standalone.analyze.connect-cta.salesforce.sync-description');
    } else if (this.freshdesk) {
      return this.intl.t('standalone.analyze.connect-cta.freshdesk.sync-description');
    } else {
      return this.intl.t('standalone.analyze.connect-cta.generic.sync-description');
    }
  }

  get syncButtonText() {
    if (this.zendesk) {
      return this.intl.t('standalone.analyze.connect-cta.zendesk.sync-history-button');
    } else if (this.salesforce) {
      return this.intl.t('standalone.analyze.connect-cta.salesforce.sync-history-button');
    } else if (this.freshdesk) {
      return this.intl.t('standalone.analyze.connect-cta.freshdesk.sync-history-button');
    } else {
      return this.intl.t('standalone.analyze.connect-cta.generic.sync-history-button');
    }
  }

  get syncTitleNewDesign() {
    if (this.zendesk) {
      return this.intl.t('standalone.analyze.connect-cta.zendesk.sync-title-new-design');
    } else if (this.salesforce) {
      return this.intl.t('standalone.analyze.connect-cta.salesforce.sync-title-new-design');
    } else if (this.freshdesk) {
      return this.intl.t('standalone.analyze.connect-cta.freshdesk.sync-title-new-design');
    } else {
      return this.intl.t('standalone.analyze.connect-cta.generic.sync-title-new-design');
    }
  }
  get syncDescriptionNewDesign() {
    if (this.zendesk) {
      return this.intl.t('standalone.analyze.connect-cta.zendesk.sync-description-new-design');
    } else if (this.salesforce) {
      return this.intl.t('standalone.analyze.connect-cta.salesforce.sync-description-new-design');
    } else if (this.freshdesk) {
      return this.intl.t('standalone.analyze.connect-cta.freshdesk.sync-description-new-design');
    } else {
      return this.intl.t('standalone.analyze.connect-cta.generic.sync-description-new-design');
    }
  }
  get platformIcon() {
    if (this.zendesk) {
      return 'zendesk';
    } else if (this.freshdesk) {
      return 'freshdesk';
    } else {
      return 'salesforce';
    }
  }

  get zendesk() {
    return this.args.platform === 'zendesk';
  }

  get salesforce() {
    return this.args.platform === 'salesforce';
  }

  get freshdesk() {
    return this.args.platform === 'freshdesk';
  }
}
declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Common::ConnectCta': typeof ConnectCta;
    'standalone/common/connect-cta': typeof ConnectCta;
  }
}
